


import React, { useContext, useEffect, useReducer, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Nav, Tab } from "react-bootstrap";
import 'react-datepicker/dist/react-datepicker.css';


import { useDispatch, useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";

import { getVendorByPropIdApi } from "../../../../service/property/getVendorByProp";
import VendorTable from "../addAndListOfAllVendors/vendorTable";
import AssignedVendorTable from "./assignedVendorTable";
import AssigningVendorModal from "../assigningVendor/assigningVendorModal";
import AddVendorModal from "../addAndListOfAllVendors/addVendorModal";
import { setLoading } from "../../../../feature/authSlice";
import { findSubMenuByName } from "../../propertyList/MenuUtlis";
const ViewVendors = () => {
  const { PropertyId, customerId } = useSelector(state => state.auth)
  const { permissions } = useSelector((state) => state.permissionsData);
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const [vendorListArr, setVendorListArr] = useState([])
  const [apiLoading, setApiLoading] = useState(false)
  const [pageViewVendor, setPageViewVendor] = useState(1);
  const [pageSizeViewVendor, setPageSizeViewVendor] = useState(10);
  const [totalPageViewVendor, setTotalPageViewVendor] = useState(1);
  const [searchValueViewVendor, setSearchValueViewVendor] = useState("");
  const [totalViewVendorCount, setTotalViewVendorCount] = useState(0);
  const { permissionArr } = useSelector((state) => state.auth);

  const handleSearchViewVendor = (e) => {
    // setPage(1)

    setSearchValueViewVendor(e.target.value);
    if (searchValueViewVendor.trim().length >= 2) {
      onChangePageViewVendor(1);
    }
  };

  const handleChangeRowsPerPageViewVendor = (e) => {
    setSearchValueViewVendor("");
    setPageViewVendor(1);
    setPageSizeViewVendor(e.target.value);
  };

  const onChangePageViewVendor = (e, p) => {
    // setPage(p);
    setPageViewVendor(e);
  };
  const location = useLocation();
  const { tab, filterType } = location.state || {}; // Access state here

  const columns = [
    {
      Header: " ",
      Footer: "",
      accessor: "sd",
    },

    {
      Header: "Vendor Name ",
      Footer: "Vendor Name ",
      accessor: "VendorName",
    },

    {
      Header: "Vendor Email",
      Footer: "Vendor Email",
      accessor: "VendorEmail",
    },
    // {
    //   Header: "Vendor GSTIN",
    //   Footer: "Vendor GSTIN",
    //   accessor: "VendorGSTIN",
    // },
    {
      Header: "Vendor Code",
      Footer: "Vendor Code",
      accessor: "VendorCode",
    },
    // { Header: "Vendor PAN",
    // Footer: "Vendor PAN",
    // accessor: "VendorPAN",
    // },
    {
      Header: "Vendor Phone",
      Footer: "Vendor Phone",
      accessor: "VendorPhone",
    },
    {
      Header: "Vendor Site",
      Footer: "Vendor Site",
      accessor: "VendorSite",

    },


  ];
  // Find the index of "Vendor Site"
  const vendorSiteIndex = columns.findIndex(col => col.accessor === "VendorSite");

  // Conditional columns to insert
  const additionalColumns =
    (filterType === "Telephone" && permissionArr.some((perm) => /telephone/i.test(perm))) || permissionArr.some((perm) => /admin/i.test(perm))
      ? [
        {
          Header: "Customer Account Number",
          Footer: "Customer Account Number",
          accessor: "CustomerAccountNo",
        },
      ]
      : [];

  // Insert additional columns before "Vendor Site"
  if (vendorSiteIndex !== -1) {
    columns.splice(vendorSiteIndex, 0, ...additionalColumns);
  }


  function onLoadData() {
    setApiLoading(true)
    var data = {
      propertyId: localStorage.getItem("propId")
    }

    dispatch(getVendorByPropIdApi(data, (res) => {
      setApiLoading(false)

      setVendorListArr(res.data.result)
    }, (res) => {
      setApiLoading(false)

    }))
  }

  const [assigningVendorModalView, setAssigningVendorModalView] = useState(false)
  function handleAssigingVendorModal() {
    setAssigningVendorModalView(!assigningVendorModalView)

    if (assigningVendorModalView) {
      onLoadData()
    }
  }
  const [addVendorModalView, setAddVendorModalView] = useState(false)

  // Helper function to check if a specific action exists in a submenu
  const hasAction = (submenu, actionName) => submenu?.Actions.includes(actionName);

  // Find the "Properties" menu
  const propertiesMenu = findSubMenuByName(permissions, 'Properties');
  const listPropertyMenu = propertiesMenu ? findSubMenuByName(propertiesMenu?.SubMenus, 'List Property') : null;
  const newSubMenu = listPropertyMenu ? findSubMenuByName(listPropertyMenu?.SubMenus, 'New') : null;
  const newViewVendorSubMenu = listPropertyMenu ? findSubMenuByName(newSubMenu?.SubMenus, 'ViewVendors') : null;
  const approvedSubMenu = listPropertyMenu ? findSubMenuByName(listPropertyMenu?.SubMenus, 'Approved') : null;
  const approvedViewVendorSubMenu = listPropertyMenu ? findSubMenuByName(approvedSubMenu?.SubMenus, 'ViewVendors') : null;
  const rejectedSubMenu = listPropertyMenu ? findSubMenuByName(listPropertyMenu?.SubMenus, 'Rejected') : null;
  const rejectedViewVendorSubMenu = listPropertyMenu ? findSubMenuByName(rejectedSubMenu?.SubMenus, 'ViewVendors') : null;

  const canNewAddNewVendors = newViewVendorSubMenu ? hasAction(newViewVendorSubMenu, 'AddNewVendors') : false;
  const canApprovedAddNewVendors = approvedViewVendorSubMenu ? hasAction(approvedViewVendorSubMenu, 'AddNewVendors') : false;
  const canRejectedAddNewVendors = rejectedViewVendorSubMenu ? hasAction(rejectedViewVendorSubMenu, 'AddNewVendors') : false;
  const canNewAssignNewVendors = newViewVendorSubMenu ? hasAction(newViewVendorSubMenu, 'AssignNewVendors') : false;
  const canApprovedAssignNewVendors = approvedViewVendorSubMenu ? hasAction(approvedViewVendorSubMenu, 'AssignNewVendors') : false;
  const canRejectedAssignNewVendors = rejectedViewVendorSubMenu ? hasAction(rejectedViewVendorSubMenu, 'AssignNewVendors') : false;

  useEffect(() => {
    onLoadData()
  }, [])

  return (
    <>
      <ToastContainer />
      <div className="row d-flex justify-content-between">
        <div className="row">
          <div className="col-xxl-12">
            <div className="card">


              <Tab.Container defaultActiveKey="Pending">
                <div className="card-header border-0 pb-2 flex-wrap">
                  <div className="d-flex">
                    <i className="material-icons" style={{ cursor: 'pointer', marginRight: '12px', marginTop: '1px' }} onClick={() => window.history.go(-1)}>chevron_left</i>
                    <h4 className="heading me-2">Assigned Vendor List</h4>
                  </div>
                  <div >
                    {tab === 'new' && <>
                      <button disabled={canNewAddNewVendors ? false : true} style={{ marginRight: '10px' }} type="submit" className="btn btn-primary" onClick={() => { setAddVendorModalView(true) }} >
                        Add New Vendor +
                      </button>

                    </>}
                    {tab === 'approved' && <>
                      <button disabled={canApprovedAddNewVendors ? false : true} style={{ marginRight: '10px' }} type="submit" className="btn btn-primary" onClick={() => { setAddVendorModalView(true) }} >
                        Add New Vendor +
                      </button>

                    </>}
                    {tab === 'rejected' && <>
                      <button disabled={canRejectedAddNewVendors ? false : true} style={{ marginRight: '10px' }} type="submit" className="btn btn-primary" onClick={() => { setAddVendorModalView(true) }} >
                        Add New Vendor +
                      </button>

                    </>}

                    {tab === 'new' && <>
                      <button type="submit" disabled={canNewAssignNewVendors ? false : true} className="btn btn-primary" onClick={handleAssigingVendorModal} >
                        Assign New Vendor +
                      </button>

                    </>}
                    {tab === 'approved' && <>
                      <button type="submit" disabled={canApprovedAssignNewVendors ? false : true} className="btn btn-primary" onClick={handleAssigingVendorModal} >
                        Assign New Vendor +
                      </button>

                    </>}
                    {tab === 'rejected' && <>
                      <button type="submit" disabled={canRejectedAssignNewVendors ? false : true} className="btn btn-primary" onClick={handleAssigingVendorModal} >
                        Assign New Vendor +
                      </button>

                    </>}

                    {/* <button style={{marginRight:'10px'}} type="submit" className="btn btn-primary" onClick={()=>{setAddVendorModalView(true)}} >
               Add New Vendor +
                      </button> */}
                    {/* <button type="submit" className="btn btn-primary" onClick={handleAssigingVendorModal} >
                 Assign New Vendor +
                      </button> */}
                  </div>

                </div>
                <div className="card-body pt-2">

                  <AssignedVendorTable
                    column={columns}
                    rowsArr={vendorListArr}

                    showLoading={apiLoading}

                    handleChangeRowsPerPagePagination={
                      handleChangeRowsPerPageViewVendor
                    }
                    searchValuePagination={searchValueViewVendor}
                    pageSizePagination={pageSizeViewVendor}
                    handleSearchPagination={handleSearchViewVendor}
                    totalCountPagination={totalPageViewVendor}
                    handleOnChangePagination={onChangePageViewVendor}
                    totalCount={totalViewVendorCount}
                    handleLoadData={onLoadData}
                    tab={tab}
                  />
                </div>
              </Tab.Container>
            </div>
          </div>
        </div>
      </div>

      {assigningVendorModalView && <AssigningVendorModal filterType={filterType} modalView={assigningVendorModalView} handleModalView={handleAssigingVendorModal} />}
      <AddVendorModal modalType={1} vendorModalView={addVendorModalView} handleVendorModalView={() => { setAddVendorModalView(!addVendorModalView) }} handleLoadData={onLoadData} />

    </>
  );
};
export default ViewVendors;
